//@ts-check

import FileUpload from 'components/AntdFormInputs/file-upload';
import { RESULT_STATUS, UNIT_DATA_TYPE } from 'constants/constants';
import { parseHtml } from 'helpers';
import React, { useMemo } from 'react';
// @ts-ignore
import stylesCourse from 'styles/Course.module.scss';

const AssignmentResult = ({ data, showYourAnswer, iconsShow, showCorrect }) => {
  if (!showYourAnswer) return null;

  const [result] = data?.result || [];
  const isCompleted = data?.status === RESULT_STATUS.COMPLETED;

  const labelColor = iconsShow
    ? showCorrect
      ? isCompleted
        ? '#19a356'
        : '#e16969'
      : '#c1c9d4'
    : '#c1c9d4';

  const uploadProps = useMemo(
    () => ({
      upload: {
        fileList: result?.value?.map((item) => ({
          url: `${item.path}`,
          name: item.originalname,
          ...item,
        })),
        showUploadList: { showRemoveIcon: false, removeIcon: false },
      },
    }),
    [result],
  );

  return (
    <div className="mt-05">
      <span className="view-page-title">Your Answer:</span>
      <div className="whiteSpacePre freetext-correct-ans-align">
        <div>
          <div
            className={`flexRow ${stylesCourse['item-section-normal']} ${stylesCourse['item-section-enabled']}`}
            // @ts-ignore
            style={{ '--labelcolor': labelColor }}
          >
            {iconsShow && showCorrect && (
              <div
                className={
                  isCompleted
                    ? 'preview_test_correct_lebalgrade'
                    : 'preview_test_wrong_lebalgrade'
                }
                style={{ marginLeft: 'auto' }}
              >
                {isCompleted ? 'Correct' : 'Incorrect'}
              </div>
            )}

            <span className="fill-blank w-100 px-md-2 px-05 py-05">
              {[UNIT_DATA_TYPE.AUDIO, UNIT_DATA_TYPE.VIDEO, 'FILE'].includes(
                result?.type,
              ) && (
                <FileUpload
                  {...uploadProps}
                  listFileOnly
                  pureCss={`span {padding: 0px !important}`}
                />
              )}

              {result?.type === 'TEXT' &&
                parseHtml(result?.value, 'pr-1 fill-overflow-image')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentResult;
